class ApplicationInfo {
  constructor(appInfo) {
    this.appInfo = appInfo
    appInfo.Modules = appInfo.Modules.map(mod => {
      mod.Name = normalize(mod.Name)
      return mod
    })
    appInfo.AuthenticationProviders = appInfo.AuthenticationProviders.map(auth => {
      auth.Name = normalize(auth.Name)
      return auth
    })
    this.features = appInfo.Modules.reduce((result, module) => {
      (module.Features || []).forEach(f => {result[normalize(f)] = true})
      return result
    }, {})
    
  }

  getModule(name) {
    const compareTo = normalize(name)
    return this.appInfo.Modules.find(m => m.Name === compareTo)
  }

  isModuleLoaded(name) {
    return Boolean(this.getModule(name))
  }

  isFeatureEnabled(name){
    const compareTo = normalize(name)
    return Boolean(Object.keys(this.features).find(f => f === compareTo))
  }

  hasAuthenticationProvider(name) {
    const compareTo = normalize(name)
    return this.appInfo.AuthenticationProviders.filter(m => m.Name === compareTo).length > 0
  }

  getModuleConfig(name) {
    const module = this.getModule(name) || {}
    return module.Config
  }
}

function normalize(str) {
  return str.toLowerCase()
}

export default ApplicationInfo